<script lang="ts" setup>
import { useDisplay } from 'vuetify';
import SidePanelHeader from './SidePanelHeader.vue';
import { SideBarEntityType } from '../../composables/useSideBar';

withDefaults(
  defineProps<{
    title: string;
    subtitle: string;
    initials: string;
    icon: string;
    noIcon?: boolean;
    isLoading: boolean;
    selectedEntity?: SideBarEntityType;
    titleAction?: () => void;
    subtitleAction?: () => void;
    onClose?: () => void;
  }>(),
  {
    title: '',
    subtitle: '',
    initials: '',
    icon: '',
    noIcon: false,
    isLoading: false,
    titleAction: undefined,
    subtitleAction: undefined,
    onClose: undefined,
  },
);

const { smAndDown } = useDisplay();
</script>

<template>
  <v-container class="pa-0 h-100 d-flex flex-column" fluid>
    <v-row
      class="flex-0-0 position-sticky border-b-sm top-0"
      :class="smAndDown ? 'bg-surface' : 'bg-surface-container-lowest'"
      sstyle="z-index: 1"
      no-gutters
    >
      <v-col>
        <SidePanelHeader
          :is-loading="isLoading"
          :title="title"
          :subtitle="subtitle"
          :title-action="titleAction"
          :subtitle-action="subtitleAction"
          :on-close="onClose"
          :icon="icon"
          :noIcon="noIcon"
          :initials="initials"
          :selected-entity="selectedEntity"
        />
      </v-col>
    </v-row>
    <v-row class="flex-0-0 flex-column px-4 pt-2 pb-6" :class="{ 'ga-2': smAndDown, 'ga-4': !smAndDown }" no-gutters>
      <slot> </slot>
    </v-row>
    <v-spacer></v-spacer>
    <v-row class="flex-0-0 px-4 pt-2 pb-6 align-start" :class="{ 'ga-2': smAndDown, 'ga-4': !smAndDown }" no-gutters>
      <slot name="append"> </slot>
    </v-row>
  </v-container>
</template>
